import {
  faCarSolid,
  faCarsSolid,
  FaIcon,
  faUser,
  faUsers,
  IconDefinition,
} from '@/lib/fa'
import * as React from 'react'
import { Link } from 'react-router-dom'
import clx from 'classnames'

type BtnProps = {
  isActive: boolean
  icon: IconDefinition
  url?: string
 
}

const ModeBtn = ({ isActive, icon, url }: BtnProps) => {
  const anchorClassName = clx(
    'tw-flex tw-h-8 tw-w-8 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg  tw-p-1.5',
    {
      'tw-pointer-events-none tw-cursor-none  tw-bg-primary': isActive,
      '': !isActive,
    },
  )
  const iconClassName = clx(isActive ? 'tw-text-white' : 'tw-text-neutral', {
    'tw-cursor-not-allowed': !url,
  })

  if (isActive) {
    return (
      <span className={clx(anchorClassName)}>
        <FaIcon icon={icon} className={clx(iconClassName)} />
      </span>
    )
  }

  if (url) {
    return (
      <Link to={url} className={clx(anchorClassName)}>
        <FaIcon icon={icon} className={clx(iconClassName)} />
      </Link>
    )
  }

  return (
    <span className={clx(anchorClassName)}>
      <FaIcon icon={icon} className={clx(iconClassName)} />
    </span>
  )
}

type Props = {
  mode: 'single' | 'group'
  toggleUrl: string
  padding?: boolean
  vehicles?: boolean
}

export const ViewModeUi = ({ mode, toggleUrl, padding = false,  vehicles = false }: Props) => {
  return (
    <div
      className={`tw-flex tw-h-full tw-flex-shrink-0 tw-items-center tw-gap-3 tw-rounded-br-lg tw-rounded-tl-lg tw-bg-base-200 tw-px-2 ${padding ? 'tw-py-2' : ''}`}
    >
      <div className="tw-flex tw-gap-1">
        <ModeBtn
          isActive={mode === 'group'}
          url={toggleUrl ? toggleUrl : undefined}
          icon={vehicles ? faCarsSolid : faUsers}
        />
        <ModeBtn
          isActive={mode === 'single'}
          url={toggleUrl ? toggleUrl : undefined}
          icon={vehicles ? faCarSolid : faUser}
        />
      </div>
    </div>
  )
}
